import { InputData } from "./InputData";

export class LanguageInput extends InputData
{
  language:"en"|"de"|"fr"|"es"|"pt"|"it"|"ja"|"ru"|"zh" ;
}